// 后端业务(RestAPI) 服务器根地址
const BNS_SERVER = "https://www.cleanair.work";
// 后端管理业务(RestAPI) 服务器根地址
// const BNS_ADMIN_SERVER = "http://47.92.238.196:8082";  //  开发环境
const BNS_ADMIN_SERVER = "https://pro.cleanair.work/app-pro";  // 正式环境
// const BNS_ADMIN_SERVER = "https://test.craes-air.cn/app-pro";    // 测试环境


//  网页服务器地址
const WEB_SERVER = "https://pro.cleanair.work";    //  正式环境
// const WEB_SERVER = "https://test.craes-air.cn";

// const WEBSCOKET = 'wss://pro.cleanair.work/app-dev'   // 开发
const WEBSCOKET = 'wss://pro.cleanair.work/app-pro';  // 正式

// WINDY 地址
// const WINDY_SERVER = "https://pro.cleanair.work";
// const WEB_SERVER = "http://192.168.1.155:8080";
// 微信授权(RestAPI) 服务器根地址
const WX_AUTH_SERVER = "https://www.cleanair.work/web-auth";

const UrlApi = {
    // 图片路径地址
    imgIconRoot: BNS_SERVER + "/un/",
    // 校验微信
    wxCheck: WEB_SERVER + '/checkWechat',
    // 获取menuList
    menuList: BNS_ADMIN_SERVER + "/menu/list",
    // 获取数据详情
    detailsUrl: BNS_ADMIN_SERVER + "/city/data",
    // 获取全国省份
    allProvince: BNS_ADMIN_SERVER + "/address/province",
    // 获取省份下详细信息
    provinceCity: BNS_ADMIN_SERVER + "/address/city",
    // 获取区域（地区）列表
    regionCity: BNS_ADMIN_SERVER + "/region/all",
    // 热门城市选择
    hotCity: BNS_ADMIN_SERVER + "/address/cityType",
    // 图片解读信息
    graphicIdea: BNS_ADMIN_SERVER + "/graphicIdea/list",
    // 保存图片解读信息
    saveGraphicIdea: BNS_ADMIN_SERVER + "/graphicIdea/save",
    // 更新
    updateGraphicIdea: BNS_ADMIN_SERVER + "/graphicIdea/update",
    // 删除
    deleteGraphicIdea: BNS_ADMIN_SERVER + "/graphicIdea/delete",
    // 获取uuid和二维码
    qrCode: WX_AUTH_SERVER + "/qr-code-base64",
    // 登录
    loginUrl: BNS_ADMIN_SERVER + "/login",
    // 登出
    loginOut: BNS_ADMIN_SERVER + "/logout",
    // 获取登录信息
    userInfo: BNS_ADMIN_SERVER + "/account/info/outline",
    // 验证登录信息是否合法
    userInfoValid: BNS_ADMIN_SERVER + "/account/info/valid",
    // 获取解读报告列表
    getReportsLlist: BNS_ADMIN_SERVER + "/reports/list",
    // 邀请用户
    inviteUser: BNS_ADMIN_SERVER + "/odb-app/invitee/add",
    // 添加解读报告
    addReport: BNS_ADMIN_SERVER + "/reports/add",
    // 删除解读报告
    deleteReport: BNS_ADMIN_SERVER + "/reports/delete",
    // 删除解读报告中的部分
    deleteReportItem: BNS_ADMIN_SERVER + "/report/idea/delete",
    // 获取解读报告详情
    reportDetail: BNS_ADMIN_SERVER + "/reports/detail",
    // 修改报告信息
    modifyReport: BNS_ADMIN_SERVER + "/reports/summary",
    // 修改报告信息的解读
    editReportContent: BNS_ADMIN_SERVER + "/idea/content/update",
    // 删除报告信息的解读
    deleteReportContent: BNS_ADMIN_SERVER + "/idea/content/delete",
    // 解读报告定稿
    releaseReport: BNS_ADMIN_SERVER + "/reports/release",
    // 分享解读报告
    shareReport: BNS_ADMIN_SERVER + "/reports/download",
    // 城市监测列表
    cityList: BNS_ADMIN_SERVER + "/menu/list",
    // 空气质量
    airData: BNS_ADMIN_SERVER + "/common/data",

    // 空气质量排名
    airRank: BNS_ADMIN_SERVER + "/province",

    // 获取当前城市信息数据
    airLastData: BNS_ADMIN_SERVER + "/air/lastest",
    // 获取当前城市信息数据
    airLastDatas: BNS_ADMIN_SERVER + "/air/lastests",
    // 向解读报告中添加解读评论
    addShareReport: BNS_ADMIN_SERVER + "/report/idea/write",
    // 获取个人信息
    personalInfo: BNS_ADMIN_SERVER + "/account/info/get",
    // 个人信息是否合法
    personalInfoValid: BNS_ADMIN_SERVER + "/account/info/valid",
    // 角色权限版本
    personalInfoOutline: BNS_ADMIN_SERVER + "/account/info/outline",
    // 更新个人信息
    updateUserInfo: BNS_ADMIN_SERVER + "/account/info/update",
    // 更改密码
    updatePassword: BNS_ADMIN_SERVER + "/account/modifypwd",
    // 更换手机获取验证码
    getPhoneCode: BNS_ADMIN_SERVER + "/checkCode/get",
    // 更换手机
    bindPhone: BNS_ADMIN_SERVER + "/account/bindPhone",
    //微信登录
    wxLogin: BNS_ADMIN_SERVER + '/wxLogin',
    // 页面帐号登录
    webLogin: BNS_ADMIN_SERVER + '/webLogin',
    // 图片请求Url
    imgUrl: BNS_ADMIN_SERVER + '/image',
    // 个性化设置
    configInfo: BNS_ADMIN_SERVER + '/cityConfig/infoWeb',

    GetUserInfo: BNS_ADMIN_SERVER + '/user/info',


    // menu/info 查询本级菜单详情

    menuInfo: BNS_ADMIN_SERVER + '/menu/info',

    //    windy
    windy: WEB_SERVER + '/windy',

    //  自动报告&&推送报告
    informList: BNS_ADMIN_SERVER + '/inform/list',

    // 新文档下载
    minioDownloads: BNS_ADMIN_SERVER + '/minio/downloads',

    // 数据分析列表
    site: BNS_ADMIN_SERVER + "/air/list",


    //  AI 热门主题
    aiHotTopics: BNS_ADMIN_SERVER + '/ai/hotTopics',
    //  AI 常见问题
    aiFaq: BNS_ADMIN_SERVER + '/ai/faq',

    // 数据统计 allList
    airAllList: BNS_ADMIN_SERVER + '/air/allList',

    airTownList: BNS_ADMIN_SERVER + '/air/townList',

    //  导出
    exportExcel: BNS_ADMIN_SERVER + '/air/exportExcel',

    stationList: BNS_ADMIN_SERVER + '/station/list',

    // 上传EXCEL
    uploadEcxl: BNS_ADMIN_SERVER + '/excel/upload',
    // 上传经纬度逆向文件

    uploadEcxlLonLat : BNS_ADMIN_SERVER +"/latlon/reverse",

    // 导入excel
    excelimport: BNS_ADMIN_SERVER + '/excel/import',

    excelimportExcel: BNS_ADMIN_SERVER + '/excel/importExcel',

    excelExport: BNS_ADMIN_SERVER + '/excel/export',
    excelExport2: BNS_ADMIN_SERVER + '/excel/exportExcel',
    //  模板下载
    exceldownload: BNS_ADMIN_SERVER + '/excel/download',

    //  上传记录
    excelexportList: BNS_ADMIN_SERVER + '/excel/exportList',

    // 映射表
    dataVocList: BNS_ADMIN_SERVER + '/dataVoc/page',
    dataVocsave: BNS_ADMIN_SERVER + '/dataVoc/save',
    dataVocupdate: BNS_ADMIN_SERVER + '/dataVoc/update',
    dataVocdelete: BNS_ADMIN_SERVER + '/dataVoc/delete',

    // 获取voc 列表
    vocDataList: BNS_ADMIN_SERVER + '/vocData/list',
    vocDatamapping: BNS_ADMIN_SERVER + '/vocData/mapping',

    //  有值率
    vocDataRate: BNS_ADMIN_SERVER + '/vocData/rate',
    vocrateExport: BNS_ADMIN_SERVER + '/vocData/rateExport',


    websocket: WEBSCOKET + '/webSocket/',

    //  站点列表数据
    vocDataAddr: BNS_ADMIN_SERVER + '/vocData/addr',
    vocDataDelete: BNS_ADMIN_SERVER + '/vocData/delete',

    vocDataDelete2: BNS_ADMIN_SERVER + '/excel/delete',

    // 城市树
    addressAddr: BNS_ADMIN_SERVER + '/address/addr',

    // 处理直辖市的 城市树
    addressMenuAddr: BNS_ADMIN_SERVER + '/address/menuAddr',

  //  区域
    addressAreaAddr: BNS_ADMIN_SERVER + '/address/areaAddr',

    //     区域配置
    reportAreaSave: BNS_ADMIN_SERVER + '/reportArea/save',
    reportAreaUpdate: BNS_ADMIN_SERVER + '/reportArea/update',
    reportAreaDelete: BNS_ADMIN_SERVER + '/reportArea/delete',
    reportAreaList: BNS_ADMIN_SERVER + '/reportArea/list',
    reportAreaInfo: BNS_ADMIN_SERVER + '/reportArea/info',

    //   方案配置
    selectSave: BNS_ADMIN_SERVER + '/select/save',
    selectUpdate: BNS_ADMIN_SERVER + '/select/update',
    selectDelete: BNS_ADMIN_SERVER + '/select/delete',
    selectList: BNS_ADMIN_SERVER + '/select/list',
    selectInfo: BNS_ADMIN_SERVER + '/select/info',
    selectUse: BNS_ADMIN_SERVER + '/select/use',
    getSelectUse: BNS_ADMIN_SERVER + '/select/isUse',

    selectBorderInfo: BNS_ADMIN_SERVER + '/select/borderInfo',
    //  获取 污染物
    consistencyAnalysisBorderInfo: BNS_ADMIN_SERVER + '/select/consistencyAnalysisBorderInfo',

    //     边界修改保存
    borderSave: BNS_ADMIN_SERVER + '/select/borderSave',
    borderUpdate: BNS_ADMIN_SERVER + '/select/borderUpdate',

    //     完整性分析
    vocDataCompleteness: BNS_ADMIN_SERVER + '/vocData/completeness',
    //  完整性导出
    completenessExcel: BNS_ADMIN_SERVER + '/vocData/completenessExport',


    //  相关性分析
    vocDataRelatedAnalysis: BNS_ADMIN_SERVER + '/vocData/relatedAnalysis',
    vocDataRelatedAnalysisSelect: BNS_ADMIN_SERVER + '/vocData/relatedAnalysisSelect',


    consistencyAnalysis: BNS_ADMIN_SERVER + '/vocData/consistencyAnalysis',

    //  Voc 头部 报告列表
    analysisReportlist: BNS_ADMIN_SERVER + '/analysisReport/list',

    // voc 报告列表
    onlineModulelist: BNS_ADMIN_SERVER + '/onlineModule/list',

    //  详情
    onlineModuleMenuInfo: BNS_ADMIN_SERVER + '/onlineModule/menuInfo',
    onlineModuleMenuPara: BNS_ADMIN_SERVER + '/onlineModule/para',

    onlineModulemenuInfoForContent: BNS_ADMIN_SERVER + '/onlineModule/menuInfoForContent',

    addressSiteName: BNS_ADMIN_SERVER + '/address/getSiteName',

    mapperCityStation: BNS_ADMIN_SERVER + '/mapperCityStation/list',

    //  综合分析 查结果
    onlineModuleProxy: BNS_ADMIN_SERVER + '/onlineModule/proxy',

    //   天蓝卫士 查结果
    dataProxy: BNS_ADMIN_SERVER + '/data/proxy',

    // 查询 报告城市与站点
    analysisReportcitys: BNS_ADMIN_SERVER + '/analysisReport/citys',

    //  查询报告数据污染物
    ocecMetalmapping: BNS_ADMIN_SERVER + '/ocecMetal/mapping',
    //  查询报告数据列表
    ocecMetallist: BNS_ADMIN_SERVER + '/analysisReport/data',
    // 下载报告
    analysisReportparticulates: BNS_ADMIN_SERVER + '/analysisReport/particulates',
    analysisReportparticulatesPdf: BNS_ADMIN_SERVER + '/analysisReport/particulatesPdf',
    ocecMetalexport: BNS_ADMIN_SERVER + '/analysisReport/export',


    //  获取报告模板
    wordtemplate: BNS_ADMIN_SERVER + '/word/template',
    // 保存 报告模板
    wordtemplateWrite: BNS_ADMIN_SERVER + '/word/templateWrite',

    //   专业图表 模块
    onlineModuleinfo: BNS_ADMIN_SERVER + '/onlineModule/info',

    //  查询数据
    onlineModuleimage: BNS_ADMIN_SERVER + '/onlineModule/image',

    //  获取word 模板
    wordTemplatelist: BNS_ADMIN_SERVER + '/wordTemplate/list',
    //  生成模板
    wordTemplategenerate: BNS_ADMIN_SERVER + '/wordTemplate/generate',
    //  修改模板
    wordTemplateupdate: BNS_ADMIN_SERVER + '/wordGenerate/update',
    //  下载模板
    wordTemplategenerateExport: BNS_ADMIN_SERVER + '/wordTemplate/generateExport',

    //  段落生成
    wordTemplategeneratePdf: BNS_ADMIN_SERVER + '/wordTemplate/generatePdf',
    // 表头预览
    wordTemplateheaderPdf: BNS_ADMIN_SERVER + '/wordTemplate/headerPdf',
    //  标题预览
    wordTemplatetitlePdf: BNS_ADMIN_SERVER + '/wordTemplate/titlePdf',

    //  获取树结构 菜单
    wordTemplatetree: BNS_ADMIN_SERVER + '/wordTemplate/tree',

    //  查询段落详情
    wordTemplateinfo: BNS_ADMIN_SERVER + '/wordTemplate/info',

    //  查询模块类型
    wordTemplatemoduleType: BNS_ADMIN_SERVER + '/wordTemplate/moduleType',

    //  历史记录
    wordTemplategenerateList: BNS_ADMIN_SERVER + '/wordGenerate/list',
    // 删除记录
    wordTemplatedelete: BNS_ADMIN_SERVER + '/wordTemplate/delete',
    //  下载
    wordTemplatedownload: BNS_ADMIN_SERVER + '/wordTemplate/download',

    //  生成模板
    wordTemplateGenerateWord: BNS_ADMIN_SERVER + '/wordTemplate/generateWord',

    //  权限判断列表
    sysMenuNav: BNS_ADMIN_SERVER + '/sys/menu/nav',

    // 数据分析菜单
    dataAnalysisNav: BNS_ADMIN_SERVER + '/dataAnalysis/nav',

    // 获取实时报告
    wordTemplategenerateReport: BNS_ADMIN_SERVER + '/wordTemplate/generateReport',


    // 开启 定时任务
    wordTaskSave: BNS_ADMIN_SERVER + '/wordTask/save',
    //  专业图表 定时任务
    wordTaskSaveApi: BNS_ADMIN_SERVER + '/wordTask/saveApi',
    //  专业图表 定时任务 详情
    wordTaskMenuIdInfo: BNS_ADMIN_SERVER + '/wordTask/menuIdInfo',

    //  查询 定时任务详情
    wordTaskInfo: BNS_ADMIN_SERVER + '/wordTask/info',

    // 关闭
    wordTaskupdate: BNS_ADMIN_SERVER + '/wordTask/update',

    // 定时任务列表
    wordTaskList: BNS_ADMIN_SERVER + '/wordTask/list',
    //  定时任务 执行记录
    wordTaskTimeList: BNS_ADMIN_SERVER + '/wordTaskTime/list',

    // 定时任务 删除
    wordTaskDelete: BNS_ADMIN_SERVER + '/wordTask/delete',  // 定时任务 删除

    //  查询已有 pdf 文件
    wordGeneratePdf: BNS_ADMIN_SERVER + '/wordGenerate/pdf',

    //  查询已有 pdf 文件
    wordTemplateprecastHead: BNS_ADMIN_SERVER + '/wordTemplate/precastHead',

    // 查询 预制表头 列表
    wordTemplatePrecastHeadList: BNS_ADMIN_SERVER + '/wordTemplate/precastHeadList',


//    获取 可以切换的 城市列表
    roleCity: BNS_ADMIN_SERVER + "/roleCity",
    roleCityTree: BNS_ADMIN_SERVER + "/roleCity/tree",
    roleList: BNS_ADMIN_SERVER + "/sys/role",
    setRoleCity: BNS_ADMIN_SERVER + "/roleCity/set",
    setRole: BNS_ADMIN_SERVER + "/sys/role/set",
    getMenuNav: BNS_ADMIN_SERVER + "/sys/menu/menuNav",
    //  数据分析  / 光化学污染 站点查询
    vocDataAnalysis: BNS_ADMIN_SERVER + "/vocDataAnalysis",
    //  获取光污染数据
    vocDataAnalysisProxy: BNS_ADMIN_SERVER + "/vocDataAnalysis/proxy",

    wordTemplateWordList: BNS_ADMIN_SERVER + "/wordTemplate/wordList",

    wordTemplateId: BNS_ADMIN_SERVER + "/wordTemplate/id",
    wordTemplateWordParamInfo: BNS_ADMIN_SERVER + "/wordTemplate/wordParamInfo",
    wordTemplateApiInfo: BNS_ADMIN_SERVER + "/wordTemplate/apiInfo",
    menuCityTree: BNS_ADMIN_SERVER + "/menuCity/tree",
    gzDataToken: BNS_ADMIN_SERVER + "/gzData/token",

    thresholdStationsList: BNS_ADMIN_SERVER + "/threshold/stationsList",
    thresholdSave: BNS_ADMIN_SERVER + "/threshold/save",
    thresholdUpdate: BNS_ADMIN_SERVER + "/threshold/update",
    thresholdDelete: BNS_ADMIN_SERVER + "/threshold/delete",
    thresholdList: BNS_ADMIN_SERVER + "/threshold/list",
    suzhouData: BNS_ADMIN_SERVER + "/suzhouData/list",
    suzhouDataAudit: BNS_ADMIN_SERVER + "/suzhouData/audit",

    // 案例库
    // calendarList: BNS_ADMIN_SERVER + "/calendar/list",
    // calendarInfo: BNS_ADMIN_SERVER + "/calendar/info",
    // calendar: BNS_ADMIN_SERVER + "/calendar",
    calendarList: BNS_ADMIN_SERVER + "/process/list",
    calendarInfo: BNS_ADMIN_SERVER + "/process/info",
    calendar: BNS_ADMIN_SERVER + "/process",

    //  增加案例库报告
    caseLibrarySave: BNS_ADMIN_SERVER + "/caseLibrary/save",
    caseLibraryDelete: BNS_ADMIN_SERVER + "/caseLibrary/delete",
    caseLibraryUpdate: BNS_ADMIN_SERVER + "/caseLibrary/update",
    caseLibraryList: BNS_ADMIN_SERVER + "/caseLibrary/list",
    caseMenu: BNS_ADMIN_SERVER + "/caseMenu",
    fileUpload: BNS_ADMIN_SERVER + "/file/upload",


    /**
     * 定时图片推送
     * */
    pushRegionTree:BNS_ADMIN_SERVER+'/push/area',
    pushMenuTree:BNS_ADMIN_SERVER+'/push/menu',
    pushModule:BNS_ADMIN_SERVER+'/push/module',
    pushPagejob:BNS_ADMIN_SERVER+'/push/pagejob',
    pushInfo:BNS_ADMIN_SERVER+'/push/info/',

    pushRun:BNS_ADMIN_SERVER+'/push/run',
    pushSavejob:BNS_ADMIN_SERVER+'/push/savejob',
    pushUpdatejob:BNS_ADMIN_SERVER+'/push/updatejob',
    pushPausejob:BNS_ADMIN_SERVER+'/push/pausejob',
    pushResumejob:BNS_ADMIN_SERVER+'/push/resumejob',
    pushDeletejob:BNS_ADMIN_SERVER+'/push/deletejob',
    pushLogpage:BNS_ADMIN_SERVER+'/push/logpage',
    // push:BNS_ADMIN_SERVER+'',


    /**
     *
     * 数据分析系统
     *
     * */

    maperTablelist:BNS_ADMIN_SERVER+'/maperTable/list',
    mapperOperationstep:BNS_ADMIN_SERVER+'/mapperOperation/step',
    mapperOperationexist:BNS_ADMIN_SERVER+'/mapperOperation/exist',
    mapperOperationupload:BNS_ADMIN_SERVER+'/mapperOperation/upload',
    mapperOperationmapping:BNS_ADMIN_SERVER+'/mapperOperation/mapping',
    mapperOperationmappingList:BNS_ADMIN_SERVER+'/mapperOperation/mappingList',
    mapperOperationcustomizeSet:BNS_ADMIN_SERVER+'/mapperOperation/customizeSet',
    mapperOperationcustomizeList:BNS_ADMIN_SERVER+'/mapperOperation/customizeList',
    mapperOperationcustomizeinfo:BNS_ADMIN_SERVER+'/mapperOperation/customizeinfo',
    mapperOperationpage:BNS_ADMIN_SERVER+'/mapperOperation/page',
    mapperOperationinfoPage:BNS_ADMIN_SERVER+'/mapperOperation/infoPage',
    mapperOperationinfo:BNS_ADMIN_SERVER+'/mapperOperation/info/',
    mapperOperationinfoPage2:BNS_ADMIN_SERVER+'/mapperOperation/infoPage/',
    mapperOperationdownload:BNS_ADMIN_SERVER+'/mapperOperation/download',
    mapperOperationdel:BNS_ADMIN_SERVER+'/mapperOperation/del',
    DataSourceAnalysisfieldList:BNS_ADMIN_SERVER+'/dataSourceAnalysis/fieldList',
    DataSourceAnalysislist:BNS_ADMIN_SERVER+'/dataSourceAnalysis/list',
    DataSourceAnalysisexport:BNS_ADMIN_SERVER+'/dataSourceAnalysis/export',
    ssoauthjump:BNS_ADMIN_SERVER+'/sso/auth/jump',


    //  自动报告模块
    uploadReportBot : BNS_ADMIN_SERVER +"/reportBot/upload",
    generateReportBot : BNS_ADMIN_SERVER +"/reportBot/generate",
    pageReportBot : BNS_ADMIN_SERVER +"/reportBot/page",
    downloadReportBot : BNS_ADMIN_SERVER +"/reportBot/download",
    deleteReportBot : BNS_ADMIN_SERVER +"/reportBot/delete/",
    retryReportBot : BNS_ADMIN_SERVER +"/reportBot/retry/",



//      外部系统接入
    ssoLogin: BNS_ADMIN_SERVER + '/sso/auth/login',
    captcha: BNS_ADMIN_SERVER + '/captcha',
    captchacheck: BNS_ADMIN_SERVER + '/check',

}
export default UrlApi
